package com.ervasstudio.tracoemovimento.pages.projecto

import androidx.compose.runtime.Composable
import com.ervasstudio.tracoemovimento.util.Res
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.bottom
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.objectFit
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.right
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.silk.components.graphics.Image
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

@Composable
fun HeroProjecto(isMobile: Boolean) {
    Box(
        modifier = Modifier.fillMaxWidth().position(Position.Relative),
        contentAlignment = Alignment.TopCenter
    ) {
        Image(
            modifier = Modifier.fillMaxWidth().objectFit(ObjectFit.Fill),
            src = Res.Image.bg_projecto,
        )

        Column(horizontalAlignment = Alignment.CenterHorizontally) {
            HeroStrokeText("ANIMAÇÃO", isMobile, topPadding = 20.px)
            HeroStrokeText("ÁFRICA", isMobile)
        }

        Image(
            modifier = Modifier
                .zIndex(8)
                .width(if (isMobile) 12.cssRem else 40.cssRem)   // era 40.cssRem
                .objectFit(ObjectFit.Fill)
                .position(Position.Absolute)
                .bottom(if (isMobile) (-0.4).cssRem else (-1).cssRem)
                .right(if (isMobile) 5.percent else 20.percent),   // era 20.percent
            src = Res.Image.halter,
        )
        Box(modifier = Modifier.height(if (isMobile) 20.px else 50.px))

        MarqueeRow()
    }
}